<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    :max-width="`${width}px`"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon flat @click="$emit('cancel')">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titleDialog }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon :dark="!sameInput" :disabled="sameInput" @click="submit">
          <v-icon>save</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 1000px">
        <v-form>
          <v-text-field
            v-if="dialog"
            autofocus
            append-icon="star"
            type="text"
            v-model="input.trainer_divisi"
            v-validate="'required'"
            name="trainer_divisi"
            data-vv-name="trainer_divisi"
            label="Nama Divisi"
            data-vv-as="Nama Divisi"
            :error-messages="errors.collect('trainer_divisi')"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import _ from "lodash";
import { mapState } from "vuex";

const defaultInput = {
  trainer_divisi: ""
};

export default {
  name: "trainer-divisi-input",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    primary_key: {
      type: String,
      default: ""
    },
    primary_field: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      input: _.cloneDeep(defaultInput),
      dataInjected: null
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("trainer_divisi", ["trainer_divisi"]),
    source() {
      return this.$store.state[this.primary_field][this.primary_field];
    },
    titleDialog() {
      let title = this.action == "ADD" ? "TAMBAH" : "EDIT";
      return `${title} ${this.title}`;
    },
    sameInput() {
      return _.isEqual(this.input, this.dataInjected);
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store
            .dispatch(
              `${this.primary_field}/${this.action}_${this.title}`,
              this.input
            )
            .then(() => {
              let new_id =
                this.action == "ADD"
                  ? _.last(this.source)[this.primary_key]
                  : null;
              this.$emit("submitted", new_id);
            })
            .catch();
        } else {
          this.$store.commit(
            "ERROR",
            "Ada field yang masih error, cek kembali isian form!"
          );
        }
      });
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$validator.reset();
        if (this.action == "ADD") {
          this.dataInjected = _.cloneDeep(defaultInput);
        } else {
          this.dataInjected = _.cloneDeep(this.data);
        }
        this.input = _.cloneDeep(this.dataInjected);
      }
    }
  },
  mounted() {
    this.$store.dispatch("trainer_divisi/GET_TRAINER_DIVISI");
  }
};
</script>
